





























































































































import { Component, Emit, Prop } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators';
import { EventFormData, EventResponse, EventUpdate } from '@/model/Event';
import { Project } from '@/model/Project';
import FormSelector from '@/components/form/FormSelector.vue';
import DateTimePicker from '@/components/form/DateTimePicker.vue';
import EventTypePicker from '@/components/event/EventTypePicker.vue';
import FormInput from '@/components/form/FormInput.vue';
import FormValidationMixin from '@/mixins/FormValidationMixin';
import { mixins } from 'vue-class-component';
import { FormItem } from '@/model/form/FormItem';

@Component({
    components: {
        DateTimePicker,
        EventTypePicker,
        FormSelector,
        FormInput,
    },
})
export default class CreateEventForm extends mixins(FormValidationMixin) {
    @Prop({ default: new Array<Project>() }) projects!: Project[];

    @Prop() item!: EventResponse;

    @Prop({ type: Boolean, default: false }) isUpdate!: boolean;

    formData = {
        projectId: null,
        startDate: this.item?.startDate,
        name: this.item?.name,
        description: this.item?.description,
        type: this.item?.type,
    } as EventFormData;

    submitted = false;

    @Validations()
    validations = {
        formData: {
            projectId: {
                required: requiredIf(() => {
                    return !this.isUpdate;
                }),
            },
            name: {
                required,
                maxLength: maxLength(35),
            },
            description: {
                maxLength: maxLength(1000),
            },
        },
    };

    @Emit()
    submit(): EventFormData | EventUpdate {
        if (this.isUpdate) {
            return {
                eventId: this.item.id,
                eventRequest: {
                    selectedStartDate: this.item.selectedStartDate,
                    selectedEndDate: this.item.selectedEndDate,
                    step: this.item.step,
                    ...this.formData,
                },
            };
        }
        return this.formData;
    }

    onSubmit(): void {
        this.submitted = true;

        this.$v.formData.$touch();
        if (!this.$v.$invalid) {
            this.submit();
        }
    }

    get projectOptions(): FormItem[] {
        return this.projects.map((project) => {
            return { id: project.id, name: project.name, value: project.id };
        });
    }
}
